import RequestQuery from "../../domain/core/request/RequestQuery";
import { RequestModel } from "../../domain/models/Request";
import { IQueryRequestRepository } from "../../domain/ports/request/IQueryRequestRepository";
import QueryService from "../QueryService";

export class RequestQueryService
  extends QueryService<RequestModel>
  implements IQueryRequestRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const userQueryServiceForRequest = new RequestQuery(
  new RequestQueryService(BASE_URL, "requests"),
);

export { userQueryServiceForRequest };
